import { Badge } from '@/ui/components/ui/badge';
import { formatEnum } from '../../../utils/format-enum';
import { STATUS_VARIANT_MAP } from './fr-utils';

export function FRStatusBadge({ status }: { status: string }) {
	return (
		<Badge variant={STATUS_VARIANT_MAP[status] ?? 'secondary'}>
			{formatEnum(status)}
		</Badge>
	);
}
